import {
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  SimpleLoader,
  Typography,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { Controller, useForm } from "react-hook-form";
import {
  FP_ONBOARDING_CONFIG,
  FP_ONBOARDING_CONFIG_BY_ID,
} from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";

interface MFConfigFormValues {
  fpTenantId: string;
  fpClientId: string;
  fpClientSecret: string;
  cybrillaClientId: string;
  cybrillaClientSecret: string;
  // proofDetailsCallbackUrl: string;
  // esignCallbackUrl: string;
}

const MFConfiguration = ({ id }: { id: number | string }) => {
  const form = useForm<MFConfigFormValues>({
    defaultValues: {
      fpTenantId: "",
      fpClientId: "",
      fpClientSecret: "",
      cybrillaClientId: "",
      cybrillaClientSecret: "",
      // proofDetailsCallbackUrl: "",
      // esignCallbackUrl: "",
    },
  });

  const { isFetching, refetch } = useFetchQuery({
    key: ["FP_ONBOARDING_CONFIG"],
    route: FP_ONBOARDING_CONFIG(id),
    success: (res: { data: { data: MFConfigFormValues } }) =>
      form.reset(res?.data?.data),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: (values: MFConfigFormValues) =>
      axiosInstance.patch(FP_ONBOARDING_CONFIG_BY_ID(id), values),
    onSuccess: () => refetch(),
  });

  if (isFetching) return <SimpleLoader />;

  return (
    <form onSubmit={form.handleSubmit((values) => mutate(values))}>
      <Grid2 container spacing={2}>
        <Grid2 size={3}>
          <Typography fontSize={16} fontWeight={500} color="var(--neutral-500)">
            FP Credentials
          </Typography>
        </Grid2>
        <Grid2 container size={9} spacing={2}>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="fpTenantId"
              rules={{
                required: { value: true, message: "Please enter FP Tenant ID" },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="FP Tenant ID"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="fpClientId"
              rules={{
                required: {
                  value: true,
                  message: "Please enter FP Client ID",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="FP Client ID"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="fpClientSecret"
              rules={{
                required: {
                  value: true,
                  message: "Please enter FP Client Secret",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="FP Client Secret"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12}>
          <Divider />
        </Grid2>

        <Grid2 size={3}>
          <Typography fontSize={16} fontWeight={500} color="var(--neutral-500)">
            Cybrilla Credentials
          </Typography>
        </Grid2>
        <Grid2 container size={9} spacing={2}>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="cybrillaClientId"
              rules={{
                required: {
                  value: true,
                  message: "Please enter Cybrilla Client ID",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Cybrilla Client ID"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="cybrillaClientSecret"
              rules={{
                required: {
                  value: true,
                  message: "Please enter Cybrilla Client Secret",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Cybrilla Client Secret"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
        </Grid2>

        <Grid2 size={12}>
          <Divider />
        </Grid2>

        {/* <Grid2 size={3}>
          <Typography fontSize={16} fontWeight={500} color="var(--neutral-500)">
            Callback URLs
          </Typography>
        </Grid2> */}
        {/* <Grid2 container size={9} spacing={2}>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="proofDetailsCallbackUrl"
              rules={{
                required: {
                  value: true,
                  message: "Please enter Proof Details Callback URL",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="Proof Details Callback URL"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="esignCallbackUrl"
              rules={{
                required: {
                  value: true,
                  message: "Please enter eSign Callback URL",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  requiredField
                  inputLabel="eSign Callback URL"
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2> */}
        <Grid2 size={12} display="flex" justifyContent="flex-end">
          <GKButton loading={isLoading} variant="contained" type="submit">
            Save
          </GKButton>
        </Grid2>
      </Grid2>
      {/* </Grid2> */}
    </form>
  );
};

export default MFConfiguration;
